import "./about.css";
import PartnerCompanies from "../../components/partners-companies/PartnerCompanies";

function About() {
  return (
    <div className="about">
      {/* About Header */}
      <div className="about-header">
        <div className="about-header-title">
          <h1 className="animate__animated animate__fadeIn animate__slow">
            TIME - INFORMATION - MANAGEMENT - NETWORK !
          </h1>
          <p className="animate__animated animate__fadeIn animate__slow">
            <span className="bold">For 10 years, TiMN</span>&nbsp;
            builds the process depending for those cores time - information management & network . The system offers alternate methods for each business model.
          </p>
        </div>

        <div className="about-header-images-container">
          <div>
            <img src="/assets/images/about-page-img-1.webp" alt="About Image" />
          </div>
          <div>
            <img src="/assets/images/about-page-img-2.webp" alt="About Image" />
            <img src="/assets/images/about-page-img-3.webp" alt="About Image" />
          </div>
        </div>
      </div>

      {/* Our Capabilities Section */}
      <div className="our-capabilities-section">
        <div className="our-capabilities">
          <div className="our-capabilities-card">
            <h1>01</h1>
            <h2>Inspiring & growth-oriented</h2>
            <p>
              Team with folks who really know their stuff in design, development, and other areas is such a valuable learning experience.
            </p>
            <img
              src="/assets/images/our-capabilities-img-1.webp"
              alt="Our Capabilities Image"
            />
          </div>

          <div className="our-capabilities-card">
            <h1>02</h1>
            <h2>Global & open-minded</h2>
            <p>
              Our crew is made up of some pretty knowledge to the table. We’re all about creating a space where it’s cool.
            </p>
            <img
              src="/assets/images/our-capabilities-img-2.webp"
              alt="Our Capabilities Image"
            />
          </div>

          <div className="our-capabilities-card">
            <h1>03</h1>
            <h2>Adaptive & flexible</h2>
            <p>
              We’re here to give you that freedom, and we believe in what you can do—so feel free to work however you like!
            </p>
            <img
              src="/assets/images/our-capabilities-img-3.webp"
              alt="Our Capabilities Image"
            />
          </div>
        </div>

        <h1>
          As a team we strive together, collaborate and provide the best
          experience for our clients.
        </h1>

        <div className="our-achievements">
          <div className="our-achievement">
            <h1>31</h1>
            <p>Passionate People</p>
          </div>
          <div className="our-achievement">
            <h1>50+</h1>
            <p>Projects Completed</p>
          </div>
          <div className="our-achievement">
            <h1>10Y</h1>
            <p>Of Experience</p>
          </div>
        </div>
      </div>

      {/* About Partners Section */}
      <PartnerCompanies />
    </div>
  );
}

export default About;
